/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CheckStageConfig,
    CheckStageConfigFromJSON,
    CheckStageConfigFromJSONTyped,
    CheckStageConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface RequiredCheckRule
 */
export interface RequiredCheckRule {
    /**
     * Case-insensitive substring matched against check-run names and commit-status contexts. Unique within a repo.
     * @type {string}
     * @memberof RequiredCheckRule
     */
    checkPattern: string;
    /**
     * 
     * @type {CheckStageConfig}
     * @memberof RequiredCheckRule
     */
    reminder?: CheckStageConfig;
    /**
     * 
     * @type {CheckStageConfig}
     * @memberof RequiredCheckRule
     */
    warning?: CheckStageConfig;
    /**
     * 
     * @type {CheckStageConfig}
     * @memberof RequiredCheckRule
     */
    autoClose?: CheckStageConfig;
}

export function RequiredCheckRuleFromJSON(json: any): RequiredCheckRule {
    return RequiredCheckRuleFromJSONTyped(json, false);
}

export function RequiredCheckRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequiredCheckRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkPattern': json['checkPattern'],
        'reminder': !exists(json, 'reminder') ? undefined : CheckStageConfigFromJSON(json['reminder']),
        'warning': !exists(json, 'warning') ? undefined : CheckStageConfigFromJSON(json['warning']),
        'autoClose': !exists(json, 'autoClose') ? undefined : CheckStageConfigFromJSON(json['autoClose']),
    };
}

export function RequiredCheckRuleToJSON(value?: RequiredCheckRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkPattern': value.checkPattern,
        'reminder': CheckStageConfigToJSON(value.reminder),
        'warning': CheckStageConfigToJSON(value.warning),
        'autoClose': CheckStageConfigToJSON(value.autoClose),
    };
}

